import { useQueryParam } from '@occc-app/hooks/useQueryParam';
import { deletePaginationParams } from '@occc-app/hooks/usePaginationParams';

export const useDateQueryParam = (keyParam: string, beforeParam?: string, afterParam?: string) => {
  const result = useQueryParam<Date | undefined>(
    (searchParams) => {
      const startDate = searchParams.get(keyParam);
      if (!startDate) {
        return undefined;
      }

      return new Date(startDate);
    },
    (value, searchParams) => {
      if (value) {
        searchParams.set(keyParam, value.toISOString());
      } else {
        searchParams.delete(keyParam);
      }

      deletePaginationParams(searchParams, beforeParam, afterParam);
    },
  );

  return result;
};
